var exports = {
  "YB": "xa15a2ab7--956a13--columns",
  "fi": "xa15a2ab7--956a13--column",
  "nM": "xa15a2ab7--956a13--row",
  "Uq": "xa15a2ab7--956a13--value",
  "JL": "xa15a2ab7--956a13--faq",
  "Lf": "xa15a2ab7--956a13--brochure",
};

module.exports = exports;
